import { tickerItems } from "@/mocks/homeData";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50 overflow-hidden">
      <div className="flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 bg-primary-500 text-background-50 px-4 md:px-6 py-3 font-label text-xs md:text-sm font-medium whitespace-nowrap">
          <i className="ri-live-line"></i>
          <span>实时播报</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2.5 px-5 md:px-7 py-3 text-xs md:text-sm whitespace-nowrap text-background-100"
              >
                <i className="ri-notification-2-line text-primary-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}